import { Badge, type BadgeVariant } from '@/components/ui/badge'
import { PolicyChangeStatus } from '@/models/policyChange'
import { STATUS_LABELS, WITHDRAWN_LABEL } from './policyChangeCopy'

const STATUS_BADGES: Partial<Record<PolicyChangeStatus, BadgeVariant>> = {
  [PolicyChangeStatus.NEEDS_INFO]: 'warning',
  [PolicyChangeStatus.QUOTE_READY]: 'warning',
  [PolicyChangeStatus.COMPLETE]: 'success',
}

/**
 * The request's status; one the broker is waiting on the customer to answer says so whatever its step. A sent
 * request the customer called off reads as withdrawn, a draft as canceled.
 */
export function PolicyChangeStatusBadge({
  status,
  submitted,
  waitingOnCustomer = false,
}: {
  status: PolicyChangeStatus
  submitted: boolean
  waitingOnCustomer?: boolean
}) {
  if (waitingOnCustomer && !STATUS_BADGES[status]) {
    return <Badge variant="warning">{STATUS_LABELS[PolicyChangeStatus.NEEDS_INFO]}</Badge>
  }
  const label = status === PolicyChangeStatus.CANCELED && submitted ? WITHDRAWN_LABEL : STATUS_LABELS[status]
  return <Badge variant={STATUS_BADGES[status] ?? 'secondary'}>{label}</Badge>
}
